import { ParentalSetup } from "./ParentalSetup";

export default [
    {
        path: "parental-setup",
        component: ParentalSetup,
        options: {
            clearHistory: true
        }
    }
];
